import { v4 as uuidv4 } from 'uuid';

export enum TracingHeaderKey {
	InfaTID = 'X-INFA-TID',
	InfaTraceEvent = 'X-INFA-TRACEEVENT',
	CorrelationId = 'CORRELATION-ID',
	OperationId = 'OPERATION-ID',
	InfaLogCtx = 'X_INFA_LOG_CTX',
}

export const getTracingHeaders = (traceId: string = uuidv4()) => ({
	[TracingHeaderKey.InfaTID]: traceId,
	[TracingHeaderKey.CorrelationId]: traceId,
	[TracingHeaderKey.OperationId]: traceId,
	[TracingHeaderKey.InfaLogCtx]: `req_id=${traceId}`,
});
